module.exports = __webpack_public_path__ + "img/1.1569eb00.jpg";